import React from 'react';
import { CheckIcon } from 'lucide-react';
export function PositioningSection() {
  const capabilities = ['Produces assets from structured briefs', 'Scores clarity, positioning strength, and conversion intent', 'Repairs weak outputs automatically', 'Publishes directly into production environments', 'Tracks CTA → form → conversation → booked → won', 'Surfaces what messaging actually drives pipeline'];
  return <section className="w-full py-16 md:py-24 px-4" data-id="element-190">
      <div className="container max-w-5xl mx-auto" data-id="element-191">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-6 text-center leading-tight" data-id="element-192">
          Autonomous Automation for Marketing Enablement
        </h2>

        <div className="space-y-8 text-lg" data-id="element-193">
          <p className="text-xl text-center text-muted-foreground leading-relaxed max-w-4xl mx-auto" data-id="element-194">
            Most AI tools generate content. WisePilot governs how it's
            generated, where it's deployed, and how it improves over time.
          </p>

          <div className="bg-card rounded-2xl p-8 border border-border shadow-sm" data-id="element-195">
            <p className="text-lg font-semibold text-foreground mb-6" data-id="element-196">
              The system:
            </p>

            <div className="space-y-4" data-id="element-197">
              {capabilities.map((capability, index) => <div key={index} className="flex items-start gap-3" data-id="element-198">
                  <CheckIcon className="h-6 w-6 text-[hsl(var(--brand-blue-light))] dark:text-[hsl(var(--brand-blue-dark))] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-199" />
                  <span className="text-base text-muted-foreground leading-relaxed" data-id="element-200">
                    {capability}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="space-y-4 pt-6 text-center max-w-4xl mx-auto" data-id="element-201">
            <p className="text-xl font-bold text-foreground leading-relaxed" data-id="element-202">
              It doesn't assist marketers.
            </p>
            <p className="text-xl font-bold text-foreground leading-relaxed" data-id="element-203">
              It operates alongside them — and tightens the system continuously.
            </p>
          </div>
        </div>
      </div>
    </section>;
}